module.exports = __webpack_public_path__ + "static/media/logo-nrk.0276b4b3.png";